type Props = {
  displayText: string
}

export default function LightningDealHeader({ displayText }: Props) {
  return (
    <div
      className={
        'bg-[#DC2626] text-color-gray5 text-ss-bold w-96 rounded-t xl pt-1 text-center flex flex-col items-center gap-1'
      }
    >
      {displayText}
    </div>
  )
}
